// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"725":"426e75b1","2002":"5bc02827","2741":"d40438d9","6570":"7407b49a"}[chunkId] + ".chunk.css";
};